<div class="ccs-admin-container">
    <div class="ccs-admin-header">
      <h2>CCS Admin Module</h2>
      <p>Manage Clinical Case Simulations for students</p>
    </div>
  
    <div class="ccs-admin-tabs">
      <div class="tab-navigation">
        <button 
          class="tab-button" 
          [class.active]="activeTab === 'practice-cases'"
          (click)="switchTab('practice-cases')">
          <i class="fa fa-stethoscope"></i>
          Practice Cases
        </button>
        <button 
          class="tab-button" 
          [class.active]="activeTab === 'interactive-cases'"
          (click)="switchTab('interactive-cases')">
          <i class="fa fa-users"></i>
          Interactive Cases
        </button>
      </div>
  
      <div class="tab-content">
        <div *ngIf="activeTab === 'practice-cases'" class="tab-panel">
          <app-admin-practise-case></app-admin-practise-case>
        </div>

        <div *ngIf="activeTab === 'interactive-cases'" class="tab-panel">
            <app-admin-interactive-case></app-admin-interactive-case>
          </div>
        
        
      </div>
    </div>
  </div> 